// src/modules/ButtonHamburgerMenu.jsx

import debounce from "lodash.debounce";

export default function ButtonHamburgerMenu() {
 const menu = document.getElementById("js_menu");
 const menuAlt = document.getElementById("js_menu_alt"); // 新しいIDを取得
 const elBody = document.getElementsByTagName("body")[0];
 const globalNav = document.getElementById("js_global_nav");
 // const pageMain = document.getElementById("page_main");
 const focusTrap = document.getElementById("js_focus_trap"); //フォーカストラップを設定する
 let scrollpos; // スクロールの位置を入れる場所

 function toggleMenu(event) {
  event.stopPropagation(); // バブリングを止める

  elBody.classList.toggle("is-drawer--active");
  if (elBody.classList.contains("is-drawer--active")) {
   // ハンバーガーメニューを開いている時
   menu.classList.add("is-open");
   menu.setAttribute("aria-label", "グローバルナビゲーションを閉じる");
   menu.setAttribute("aria-expanded", true);
   globalNav.inert = false;
   scrollpos = window.scrollY; // 現在のスクロール位置を取得する
   elBody.classList.add("is-fixed");
   elBody.style.top = scrollpos * -1 + "px"; // bodyのtopにスクロール位置を付与する
   elBody.style.position = "static"; // body要素のpositionプロパティをstaticに変更する
   menu.focus();
  } else {
   // ハンバーガーメニューを閉じている時
   menu.classList.remove("is-open");
   menu.setAttribute("aria-label", "グローバルナビゲーションを開く");
   menu.setAttribute("aria-expanded", false);
   globalNav.inert = true;
   elBody.classList.remove("is-fixed");
   window.scrollTo(0, scrollpos);
   menu.focus();
  }
 }

 // ハンバーガーメニューをクリックした時の処理
 document.addEventListener("DOMContentLoaded", function () {
  menu.addEventListener("click", toggleMenu);

  if (menuAlt) {
   menuAlt.addEventListener("click", toggleMenu); // 新しい要素にイベントリスナーを追加
  }

  // ウィンドウリサイズ時に処理を実行する関数
  const handleResize = debounce(() => {
   const windowWidth = window.innerWidth;
   if (windowWidth <= 768 && !menu.classList.contains("is-open")) {
    // 768px以下の画面幅でハンバーガーメニューを開いていない時
    globalNav.inert = true;
   } else {
    // 769px以上の画面幅でリサイズ時にハンバーガーメニューを閉じる。最初の状態（リセット）にする。
    elBody.classList.remove("is-drawer--active", "is-fixed");
    menu.classList.remove("is-open");
    menu.setAttribute("aria-label", "グローバルナビゲーションを開く");
    menu.setAttribute("aria-expanded", false);
    globalNav.inert = false;
   }
  }, 200);

  // 769px以上の画面幅でリサイズ時にhandleResize()を実行する。debounce()関数で処理を遅延させる。
  window.addEventListener("resize", handleResize);
  handleResize(); // ページ読み込み時にも実行する
 });

 function hashLink() {
  const hashes = document.querySelectorAll("#menu a.p-hash[href*='#']");
  hashes.forEach(function (hash) {
   hash.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation(); // バブリングを止めることで、不要なイベント発火を防ぐ
    const windowWidth = window.innerWidth;

    if (windowWidth <= 768) {
     // 768px以下の画面幅でハンバーガーメニューを開いている時
     globalNav.inert = true;
     elBody.classList.remove("is-drawer--active", "is-fixed");
     menu.classList.remove("is-open");
     menu.setAttribute("aria-label", "グローバルナビゲーションを開く");
     menu.setAttribute("aria-expanded", false);
     window.scrollTo(0, scrollpos); // スクロール位置を開いた時の位置へ戻す
    } else {
     // 769px以上の画面幅でハンバーガーメニューを開いていない時
     globalNav.inert = false;
    }
   });
  });
 }

 hashLink(); // hashLink()関数を呼び出す

 // フォーカストラップ制御
 focusTrap.addEventListener("focus", (e) => {
  menu.focus();
 });
}
